/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentLearningEventParticipantCreateResponse,
  ContentLearningEventParticipantIndexResponse,
  ContentLearningEventParticipantShowResponse,
  ContentLearningEventParticipantUpdateResponse,
  DocumentCertificateResponse,
  ParticipantCreate,
  ParticipantUpdate,
} from '../models';
import {
    ContentLearningEventParticipantCreateResponseFromJSON,
    ContentLearningEventParticipantCreateResponseToJSON,
    ContentLearningEventParticipantIndexResponseFromJSON,
    ContentLearningEventParticipantIndexResponseToJSON,
    ContentLearningEventParticipantShowResponseFromJSON,
    ContentLearningEventParticipantShowResponseToJSON,
    ContentLearningEventParticipantUpdateResponseFromJSON,
    ContentLearningEventParticipantUpdateResponseToJSON,
    DocumentCertificateResponseFromJSON,
    DocumentCertificateResponseToJSON,
    ParticipantCreateFromJSON,
    ParticipantCreateToJSON,
    ParticipantUpdateFromJSON,
    ParticipantUpdateToJSON,
} from '../models';

export interface CompanySpacesLearningEventLearningEventIdParticipantsGetRequest {
    learningEventId: number;
    fullName?: string;
    page?: number;
    perPage?: number;
    sort?: string;
}

export interface CompanySpacesLearningEventLearningEventIdParticipantsIdCertificateGetRequest {
    learningEventId: number;
    id: string;
}

export interface CompanySpacesLearningEventLearningEventIdParticipantsIdDeleteRequest {
    learningEventId: number;
    id: string;
}

export interface CompanySpacesLearningEventLearningEventIdParticipantsIdGetRequest {
    learningEventId: number;
    id: string;
}

export interface CompanySpacesLearningEventLearningEventIdParticipantsIdPutRequest {
    learningEventId: number;
    id: string;
    body?: ParticipantUpdate;
}

export interface CompanySpacesLearningEventLearningEventIdParticipantsPostRequest {
    learningEventId: number;
    body?: ParticipantCreate;
}

/**
 * 
 */
export class ParticipantApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentLearningEventParticipantIndexResponse>>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.fullName !== undefined) {
            queryParameters['full_name'] = requestParameters.fullName;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.perPage !== undefined) {
            queryParameters['per_page'] = requestParameters.perPage;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentLearningEventParticipantIndexResponseFromJSON));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsGet(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentLearningEventParticipantIndexResponse>> {
        const response = await this.companySpacesLearningEventLearningEventIdParticipantsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdCertificateGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdCertificateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentCertificateResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdCertificateGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdCertificateGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants/{id}/certificate`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentCertificateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdCertificateGet(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdCertificateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentCertificateResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdParticipantsIdCertificateGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdDeleteRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants/{id}`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdDelete(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesLearningEventLearningEventIdParticipantsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdGetRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventParticipantShowResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants/{id}`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventParticipantShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdGet(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventParticipantShowResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdParticipantsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdPutRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventParticipantUpdateResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants/{id}`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventParticipantUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsIdPut(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventParticipantUpdateResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdParticipantsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsPostRaw(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentLearningEventParticipantCreateResponse>> {
        if (requestParameters.learningEventId === null || requestParameters.learningEventId === undefined) {
            throw new runtime.RequiredError('learningEventId','Required parameter requestParameters.learningEventId was null or undefined when calling companySpacesLearningEventLearningEventIdParticipantsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/learning_event/{learning_event_id}/participants`.replace(`{${"learning_event_id"}}`, encodeURIComponent(String(requestParameters.learningEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentLearningEventParticipantCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesLearningEventLearningEventIdParticipantsPost(requestParameters: CompanySpacesLearningEventLearningEventIdParticipantsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentLearningEventParticipantCreateResponse> {
        const response = await this.companySpacesLearningEventLearningEventIdParticipantsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
